import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  makeStyles,
} from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import SettingsIcon from "@material-ui/icons/Settings";

const useStyles = makeStyles({
  listItem: {
    height: 40,
    marginTop: 7,
    width: "100%",
    "&:hover": {
      borderRadius: 20,
    },
    "& svg": {
      color: "#C9C8C8",
    },
    "& .MuiIconButton-root": {
      padding: 0,
    },
  },
  wrapperItem: {
    padding: 0,
  },
  activeListItem: {
    width: 255,
    borderRadius: 20,
    backgroundImage: "linear-gradient(278deg, #4aa9d8, #1779c0)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
  nestedListItem: {
    height: 40,
    width: 242,
    marginTop: 7,
    marginLeft: 10,
    paddingLeft: 75,
    "&:hover": {
      borderRadius: 20,
    },
    "& svg": {
      color: "#C9C8C8",
    },
  },
  activeNestedListItem: {
    borderRadius: 20,
    backgroundImage: "linear-gradient(278deg, #0F76AF, #004B81)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
});

interface OwnProps {
  handleDrawerToggle: () => void;
}
type Props = OwnProps;

const AdministracionItem: React.FC<Props> = (props) => {
  const { handleDrawerToggle } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname.startsWith("/administracion-")) {
      setOpen(false);
    }
  }, [pathname]);

  const handleClick = () => {
    setOpen((open) => !open);
  };

  return (
    <>
      <ListItem
        button
        className={classes.listItem}
        onClick={() => {
          handleClick();
        }}
      >
        <ListItem className={classes.wrapperItem}>
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Administración" />
        </ListItem>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <NavLink
            to="/administracion-empleados"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemText primary="ABM Empleados" />
              </ListItem>
            )}
          </NavLink>
          <NavLink
            to="/administracion-servicios"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemText primary="ABM Servicios" />
              </ListItem>
            )}
          </NavLink>
        </List>
      </Collapse>
    </>
  );
};

export default AdministracionItem as React.ComponentType<Props>;
